import { useContext } from 'react';
import { NotificationContext } from '../context/NotificationContext';
var useNotification = function useNotification() {
    var notificationHelpers = useContext(NotificationContext);
    if (!notificationHelpers) {
        throw new Error('useNotification must be used within the NotificationContext.Provider');
    }
    return notificationHelpers;
};
export default useNotification;
